import React from 'react'
import { Dropdown, Layout, Row, Space, Tooltip } from 'antd'
import LogoIcon from '@/assets/icons/logo'
import FlagIcon from '@/assets/icons/redflag.png'
import { NavLink } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { logOut } from '@/redux/auth/actions'
import { ArrowLeftOutlined, DownOutlined, LogoutOutlined, MenuOutlined } from '@ant-design/icons'
import { useHistory } from 'react-router-dom'
import './header.less'
import logo from '@/assets/images/Creole.png'

const Header = () => {
  const auth = useSelector((state) => state.auth)
  const dispatch = useDispatch()

  let history = useHistory()

  const items = [
    //   {
    //     label: (
    //       <a
    //         style={{ fontSize: 24 }}
    //         href="https://applyin.notion.site/ApplyIn-Blog-57900fa258ab40cd8e8fcec3994efc09?pvs=4"
    //         target="_blank"
    //       >
    //         Interview tips
    //       </a>
    //     ),
    //     key: '0'
    //   },
    //   {
    //     type: 'divider'
    //   },
    //   {
    //     label: (
    //       <a
    //         style={{ fontSize: 24 }}
    //         href="https://applyin.notion.site/Terms-and-Privacy-Policy-cb65ca863e6e418cb2f1f728a852a26c"
    //         target="_blank"
    //       >
    //         Terms & privacy
    //       </a>
    //     ),
    //     key: '1'
    //   },
    //   {
    //     type: 'divider'
    //   },
    //   {
    //     label: (
    //       <a
    //         style={{ fontSize: 24 }}
    //         href="https://support.google.com/chrome/answer/2693767?hl=en&co=GENIE.Platform%3DDesktop"
    //         target="_blank"
    //       >
    //         Microphone help
    //       </a>
    //     ),
    //     key: '3'
    //   },
    //   {
    //     type: 'divider'
    //   },
    //   {
    //     label: auth.is_authed && (
    //       <div>
    //         <a style={{ fontSize: 24 }} onClick={() => dispatch(logOut())}>
    //           Log Out <Space />
    //           <LogoutOutlined />
    //         </a>
    //       </div>
    //     ),
    //     key: '4'
    //   }
  ]

  return (
    <Layout.Header style={{ width: '100vw' }}>
      <Row className="logo-container">
        {/* <Dropdown
          menu={{ items }}
          trigger={['click']}
          autoAdjustOverflow={true}
          placement="bottomRight"
          className="menu-icon"
        >
          <a onClick={(e) => e.preventDefault()}>
            <Space style={{ fontSize: 32 }}>
              <MenuOutlined />
            </Space>
          </a>
        </Dropdown> */}
        <a href="/aiinterview/interview-type">
          {/* <LogoIcon className="logo" /> */}
          <img src={logo} className="logo" />
        </a>
      </Row>
      {/* {auth.is_authed && (
        <div className="back-icon">
          <Tooltip title="Go Back" placement="right">
            <a
              onClick={() => history.goBack()}
              style={{ backgroundColor: '#dbdbdb', width: 50, height: 50, padding: 10, borderRadius: '50%' }}
            >
              <ArrowLeftOutlined />
            </a>
          </Tooltip>
        </div>
      )} */}
      {auth.is_authed && (
        <div className="flag-icon">
          <Tooltip title="Report an issue" placement="left">
            <a href="https://docs.google.com/forms/d/1HYyFibLZxPZuiY_kIvvKpRIehy74TEt1BPSkchbERL8/edit" target="_blank">
              <img src={FlagIcon} width="100%" />
            </a>
          </Tooltip>
        </div>
      )}
      {/* {auth.is_authed && (
        <div className="logout-icon">
          <Tooltip title="Sign out" placement="left">
            <a onClick={() => dispatch(logOut())}>
              <LogoutOutlined />
            </a>
          </Tooltip>
        </div>
      )} */}
    </Layout.Header>
  )
}

export default Header
